<template>
  <div class="selectables">
    <b-form-group>
      <template #label>
        <b>Escoge los Servicios que deseas asignar:</b><br />
        <b-form-checkbox
          aria-describedby="serviceOptions"
          aria-controls="serviceOptions"
          @change="toggleAll"
        >
          Seleccionar Todos
        </b-form-checkbox>
      </template>

      <template v-slot="{ ariaDescribedby }">
        <b-form-checkbox-group
          id="serviceOptions"
          v-model="selected"
          :options="serviceOptions"
          :aria-describedby="ariaDescribedby"
          name="serviceOptions"
          class="ml-4"
          aria-label="Individual serviceOptions"
          stacked
        ></b-form-checkbox-group>
      </template>
    </b-form-group>
  </div>
</template>
<script>
export default {
  props: ["serviceOptions", "selectedServicesToAdd"],
  data() {
    return {
      selected: [],
    };
  },
  watch: {
    selected: function() {
      this.selectedServicesToAdd(this.selected);
    }
  },
  methods: {
    toggleAll(checked) {
      this.selected = checked ? this.serviceOptions.map(s => s.value) : [];
    }
  }
};
</script>
<style >
.selectables {
  background: #e0e0e0;
  padding: 10px;
  margin: 0 40px;
}
label.custom-control-label {
  margin: 0 3px !important;
  font-size: .8rem;
}
#__BVID__468__BV_label_ > b {
  font-size: .9rem;
}
</style>
